export default __webpack_public_path__ + "static/media/resources_desktop_banner.ec17f83f.png";